// Web Push (VAPID) — configuração do lado do cliente.
// A chave PÚBLICA é segura para embutir no bundle (a privada vive como secret no Supabase).
export const VAPID_PUBLIC_KEY =
  "BDlVPMDxzX_wE8kB7e8xTyzRj4ZD8VIA9wvSPQVEFiw4YVl3wckhbRYdlIP56JVeXri2JQIF1zkzPdSEPrZrsEk";

export function isPushSupported(): boolean {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

/** Converte a chave VAPID base64url para o Uint8Array exigido pelo PushManager. */
export function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}
